// @ts-nocheck
import { Component } from '@theme/component';

/**
 * A custom element that handles giftcard filter header with dropdown navigation.
 *
 * @typedef {object} GiftcardFilterHeaderRefs
 * @property {HTMLSelectElement[]} selects - The select elements.
 *
 * @extends {Component<GiftcardFilterHeaderRefs>}
 */
class GiftcardFilterHeaderComponent extends Component {
  connectedCallback() {
    super.connectedCallback?.();

    this.refs.selects = Array.from(
      this.querySelectorAll('select[data-metaobject-type]')
    );

    this.refs.selects.forEach((select) => {
      select.addEventListener('change', this.#handleSelectChange);
    });

    this.#initializeFromURL();
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    this.refs.selects.forEach((select) => {
      select.removeEventListener('change', this.#handleSelectChange);
    });
  }

  /**
   * Generates the parameter name for the select element.
   *
   * @param {HTMLSelectElement} select - The select element.
   * @returns {string} The parameter name.
   */
  #getParamName(select) {
    return 'pf_mto_::custom::' + select.name + '::value';
  }

  /**
   * Handles the select change event.
   *
   * @param {Event} event - The change event.
   */
  #handleSelectChange = (event) => {
    if (!(event.target instanceof HTMLSelectElement)) return;

    const select = event.target;
    const value = select.value;
    const metaobjectType = select.dataset.metaobjectType;
    if (!metaobjectType) return;

    const url = new URL(window.location.href);
    const paramName = this.#getParamName(select);

    if (value) {
      url.searchParams.set(paramName, value);
    } else {
      url.searchParams.delete(paramName);
    }

    window.location.href = url.toString();
  };

  /**
   * Initializes select values from URL query parameters.
   */
  #initializeFromURL() {
    if (!this.refs?.selects || !Array.isArray(this.refs.selects)) return;

    const url = new URL(window.location.href);

    this.refs.selects.forEach((select) => {
      if (!select || !select.dataset) return;
      
      const metaobjectType = select.dataset.metaobjectType;
      if (!metaobjectType) return;

      const paramName = this.#getParamName(select);
      const paramValue = url.searchParams.get(paramName);

      if (paramValue) {
        select.value = paramValue;
      }
    });
  }

}

if (!customElements.get('giftcard-filter-header')) {
  customElements.define('giftcard-filter-header', GiftcardFilterHeaderComponent);
}

